import { makeStyles } from '@material-ui/core/styles';
import { COLORS, SPACING } from '../constants';

export const useStyles = makeStyles(() => ({
  card: {
    background: COLORS.white,
    border: `1px solid ${COLORS.border}`,
    borderRadius: 10,
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
    overflow: 'hidden',
    marginBottom: SPACING.cardMarginBottom,
  },
  cardButton: {
    display: 'flex',
    alignItems: 'center',
    padding: `${SPACING.cardPadding + 4}px ${SPACING.cardPaddingHorizontal}px`,
    gap: 12,
    cursor: 'pointer',
    width: '100%',
    border: 'none',
    background: 'none',
    fontFamily: 'inherit',
    textAlign: 'left',
  },
  inheritedRow: {
    display: 'flex',
    alignItems: 'center',
    padding: `${SPACING.cardPadding + 4}px ${SPACING.cardPaddingHorizontal}px`,
    gap: 12,
  },
  cardContent: {
    flex: 1,
    minWidth: 0,
  },
  badgeRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginBottom: 10,
    flexWrap: 'wrap',
  },
  itemName: {
    fontSize: 15,
    fontWeight: 600,
    color: COLORS.body,
    letterSpacing: '0.01em',
  },
  detailRow: {
    display: 'flex',
    gap: 20,
    fontSize: 12.5,
    color: COLORS.muted,
    flexWrap: 'wrap',
    lineHeight: 1.5,
    alignItems: 'baseline',
  },
  actionsGroup: {
    display: 'flex',
    gap: 6,
    flexShrink: 0,
  },
  expandCollapseLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    fontSize: 11,
    fontWeight: 500,
    color: COLORS.primary,
    padding: '4px 10px',
    borderRadius: 6,
    background: COLORS.primaryLight,
  },
  expandCollapseIcon: {
    fontSize: 18,
  },
  deleteButton: {
    fontSize: 11,
    color: COLORS.error,
    padding: '4px 8px',
    borderRadius: 6,
    background: COLORS.errorLt,
    cursor: 'pointer',
    border: 'none',
    fontFamily: 'inherit',
  },
  editFormArea: {
    padding: `${SPACING.cardPadding}px ${SPACING.cardPaddingHorizontal}px`,
    borderTop: `1px solid ${COLORS.border}`,
    background: '#fafcfd',
  },
  editFormActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 12,
    marginTop: SPACING.formGroupGap,
  },
  deleteConfirmArea: {
    padding: `${SPACING.cardPadding}px ${SPACING.cardPaddingHorizontal}px`,
    borderTop: `1px solid ${COLORS.error}`,
    background: COLORS.errorLt,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  deleteConfirmText: {
    fontSize: 13,
    color: '#c62828',
  },
  deleteConfirmActions: {
    display: 'flex',
    gap: 12,
  },
  detailLabel: {
    color: COLORS.muted,
  },
  detailValue: {
    color: COLORS.body,
    fontWeight: 500,
  },
  detailDot: {
    color: COLORS.border,
  },
}));
